const KEY = 'trillium:hasLoggedInBefore';

export const useHasLoggedInBefore = () => ({
  hasLoggedInBefore: localStorage.getItem(KEY) === 'true',
  markLoggedInBefore: () => localStorage.setItem(KEY, 'true'),
});
